export default function parseOauthUrl(urlString: string) {
    if (!urlString) {
        return {};
    }

    let url: URL;
    try {
        url = new URL(urlString);
    } catch {
        // A malformed uri from the provider shouldn't fail the whole `oauth/`
        // response — fall back to the same shape as a missing uri.
        return {};
    }

    return {
        authorizationUrl: `${url.origin}${url.pathname}`,
        clientId: url.searchParams.get('client_id'),
        scope: url.searchParams.get('scope'),
        state: url.searchParams.get('state'),
    };
}
